import React from 'react';

import ActionLink from '../../../components/admin/ActionLink';
import InfoCard from '../../../components/admin/InfoCard';
import PageIntro from '../../../components/admin/PageIntro';
import Pill from '../../../components/admin/Pill';
import SectionCard from '../../../components/admin/SectionCard';

export default function StaffPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <PageIntro
        title="HnB staff"
        message="Manage internal HnB personnel here. This area is separate from provider-side stylists and will support staff records, role assignment, and operational access."
      />

      <SectionCard
        eyebrow="Internal operations"
        title="Staff operations are ready for the next integration step"
        message="Use this screen as the future workspace for internal HnB team records, role-based access, and operational ownership across the platform."
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          <Pill label="Internal staff only" />
          <Pill label="Roles and access" />
          <Pill label="ERP expansion ready" />
        </div>
      </SectionCard>

      <section
        style={{
          background: '#ffffff',
          border: '1px solid #e5e7eb',
          borderRadius: '16px',
          padding: '28px',
          display: 'flex',
          flexDirection: 'column',
          gap: '14px',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            width: '56px',
            height: '56px',
            borderRadius: '14px',
            background: '#eef2ff',
            color: '#4338ca',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.5rem',
            fontWeight: 700,
          }}
        >
          H
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <h2 style={{ margin: 0, fontSize: '1.15rem', color: '#111827' }}>
            No HnB staff records yet
          </h2>

          <p style={{ margin: 0, color: '#6b7280', lineHeight: 1.6, maxWidth: '60ch' }}>
            Staff data has not been populated from the backend yet. Once records are
            available, this page can support list views, staff detail pages, operational
            roles, and access-management flows for internal HnB personnel.
          </p>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          <ActionLink to="/dashboard/platform-settings" label="Review platform settings" />
          <ActionLink to="/dashboard/providers" label="Return to providers" />
        </div>
      </section>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '16px',
        }}
      >
        <InfoCard
          title="Planned records"
          body="Internal team members, role ownership, and staff lifecycle status can be surfaced here once backend records are seeded."
        />
        <InfoCard
          title="Planned actions"
          body="This module can later support onboarding, role assignment, permissions review, and deactivation workflows."
        />
        <InfoCard
          title="Terminology"
          body="In HnB, staff refers to internal HnB personnel, while stylists belong to provider-side teams."
        />
      </div>
    </div>
  );
}